import * as Yup from 'yup';
import { useState, useEffect, useContext } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate,  useParams } from 'react-router-dom';
import { mask } from "remask";
import NumberFormat from 'react-number-format';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';


// material
import { Stack, TextField, Alert, Autocomplete, MenuItem} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../../components/Button';

import {api, reiniciarToken, editarVendas, visualizarVendas, consultaClientes, consultaFornecedores, consultaProdutos, consultaCompanhiaAerea} from '../../../services/api';

// context
import { AuthContext } from '../../../contexts/auth';

import { fDateFormatCalendario } from '../../../utils/formatTime';

// ----------------------------------------------------------------------

export default function EditarVendaForm() {

  const {id} = useParams();
  const { logout } = useContext(AuthContext);

  const [dados, setDados] = useState('');

  const navigate = useNavigate();

  const [status, setStatus] = useState({
    type: '',
    mensagem: ''
  })

  const RegisterSchema = Yup.object().shape({
    data_venda: Yup.string().required('Data da Venda é obrigatório'),
    id_cliente: Yup.string().required('Cliente é obrigatório'),
    id_companhia_aerea: Yup.string().required('Companhia aérea é obrigatório'),
    origem: Yup.string().required('Origem da viagem é obrigatório'),
    destino: Yup.string().required('Destino da viagem é obrigatório'),
    data_ida: Yup.string().required('Data de ida da viagem é obrigatório'),
    codigo_reserva: Yup.string().required('O Código da Reserva da viagem é obrigatório'),
    id_fornecedor: Yup.string().required('Fornecedor é obrigatório'),
    id_produto: Yup.string().required('Produto/Serviço é obrigatório'),
    qtde_venda: Yup.string().required('Qtde de Venda é obrigatório'),
    valor_venda: Yup.string().required('Valor da Venda é obrigatório'),
  });

  const formik = useFormik({
   initialValues: {
    data_venda: '',
    id_cliente: '',
    id_companhia_aerea: '',
    origem: '',
    destino: '',
    data_ida: '',
    data_volta: '',
    codigo_reserva: '',
    id_fornecedor: '',
    id_produto: '',
    qtde_venda: '',
    valor_venda: '',
    },
    validationSchema: RegisterSchema,
    onSubmit: () => {
      navigate('/dashboard', { replace: true });
    },
  });

  const [clientes, setListCliente] = useState([]);
  const [fornecedores, setListFornecedor] = useState([]);
  const [produtos, setListProduto] = useState([]);
  const [companhiasAerea, setListCompanhiaAerea] = useState([]);

  const [produto, setProduto] = useState('');
  const [cliente, setCliente] = useState('');
  const [fornecedor, setFornecedor] = useState('');
  const [formaPagamento, setFormaPagamento] = useState('');
  const [companhiaAerea, setCompanhiaAerea] = useState('');
  
  const getListas = async () => {

    const response = await consultaClientes();

    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      response.data.forEach((valores) => {
        setListCliente(clientes => [...clientes, {id_cliente: valores.id_cliente, nome: valores.nome}])
      }); 
    };

    const responseFornecedor = await consultaFornecedores();

    if(responseFornecedor.erro === true) {
      if (responseFornecedor.mensagem === 'O Token é inválido!' || responseFornecedor.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      responseFornecedor.data.forEach((valores) => {
        setListFornecedor(fornecedores => [...fornecedores, {id_fornecedor: valores.id_fornecedor, nome_fantasia: valores.nome_fantasia}])
      }); 
    };
    
    const responseProduto = await consultaProdutos();

    if(responseProduto.erro === true) {
      if (responseProduto.mensagem === 'O Token é inválido!' || responseProduto.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      responseProduto.data.forEach((valores) => {
        setListProduto(produtos => [...produtos, {id_produto: valores.id_produto, descricao: valores.descricao}])
      }); 
    }; 

    const responseCompanhiaAerea = await consultaCompanhiaAerea();

    if(responseCompanhiaAerea.erro === true) {
      if (responseCompanhiaAerea.mensagem === 'O Token é inválido!' || responseCompanhiaAerea.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      responseCompanhiaAerea.data.forEach((valores) => {
        setListCompanhiaAerea(companhiasAerea => [...companhiasAerea, {id_companhia_aerea: valores.id_companhia_aerea, descricao: valores.descricao}])
      });
    };
  }

  const handleSubmit = async e => {
    e.preventDefault();

    const response = await editarVendas(id, formik.values);

    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
    };
  }

  const { errors, touched, isSubmitting, getFieldProps, handleBlur, handleChange, setFieldValue} = formik;

  useEffect(() => {
    
    getListas();

    const getVenda = async () => {
      
      const retorno = await reiniciarToken();

      if(retorno.erro === true) {
        if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
          logout();
        }
      }else{
        localStorage.setItem("token", retorno.data.token);
        api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
      }
      
      const response = await visualizarVendas(id);
      if(response.erro === true) {
        if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
          logout();
        }else {
          setStatus({
            type: "erro",
            mensagem: response.mensagem
          })
        }
      }else{
        setDados(response.data);
      };

      const campos = ['data_venda',
                      'data_ida',  
                      'data_volta',
                      'id_cliente',
                      'id_fornecedor',
                      'id_produto',
                      'qtde_venda',
                      'valor_venda',
                      'forma_pagamento',
                      'id_companhia_aerea',
                      'origem',
                      'destino',
                      'codigo_reserva'];

      campos.forEach((campo) => {
        if (campo === 'data_venda'){
            const data = response.data[0][campo];
            setFieldValue(campo, data, false);
        }else if (campo === 'data_ida') {
            const data = response.data[0][campo];
            setFieldValue(campo, data, false);
        }
        else if (campo === 'data_volta') {
            const data = response.data[0][campo];
            setFieldValue(campo, data, false);
        }else if (campo === 'id_cliente') {
            setFieldValue(campo, response.data[0][campo], false);
            setCliente({id_cliente: response.data[0][campo], nome: response.data[0].cliente.nome})
        }else if (campo === 'id_fornecedor') {
            setFieldValue(campo, response.data[0][campo], false);
            setFornecedor({id_fornecedor: response.data[0][campo], nome_fantasia: response.data[0].fornecedor.nome_fantasia})
        }
        else if (campo === 'id_produto') {
            setFieldValue(campo, response.data[0][campo], false);
            setProduto({id_produto: response.data[0][campo], descricao: response.data[0].produto.descricao})
        }
        else if (campo === 'forma_pagamento') {
            setFieldValue(campo, response.data[0][campo], false);
            setFormaPagamento(response.data[0][campo])
        }
        else if (campo === 'id_companhia_aerea') {
            setFieldValue(campo, response.data[0][campo], false);
            setCompanhiaAerea({id_companhia_aerea: response.data[0][campo], descricao: response.data[0].companhia_aerea.descricao})
        }
        else{
            setFieldValue(campo, response.data[0][campo], false);
        };
      })   
    }
    
    getVenda();

  } , [setFieldValue, id]);

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs} locale="pt-br" >
              <DatePicker
                label="Data Venda"
                value={formik.values?.data_venda}
                onChange={(newValue) => {
                  setFieldValue('data_venda', newValue, false); 
                }}
                renderInput={(params) => <TextField {...params} fullWidth/>}
              />
            </LocalizationProvider>
            <Autocomplete
                getOptionLabel={(resultado) => resultado.nome || ""}
                options={clientes}
                fullWidth
                value={cliente}
                onChange={(e, value) => { 
                  setFieldValue('id_cliente', value?.id_cliente, false) 
                  setCliente({id_cliente: value?.id_cliente, nome: value?.nome})
                }}
                renderInput={(params) => (<TextField {...params} 
                                            label="Cliente" 
                                            fullWidth
                                            {...getFieldProps('id_cliente')}
                                            error={Boolean(touched.id_cliente && errors.id_cliente)}
                                            helperText={touched.id_cliente && errors.id_cliente}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={formik.values?.id_cliente}
                                            />
                                          )}
                isOptionEqualToValue={(option, value) => {
                    if (value === "" || value.id_cliente === option.id_cliente)
                        return true; 
                }}
            />
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <Autocomplete
                  getOptionLabel={(resultado) => resultado.descricao || ""}
                  options={companhiasAerea}
                  fullWidth
                  value={companhiaAerea}
                  onChange={(e, value) => { 
                    setFieldValue('id_companhia_aerea', value?.id_companhia_aerea, false) 
                    setCompanhiaAerea({id_companhia_aerea: value?.id_companhia_aerea, descricao: value?.descricao})
                  }}
                  renderInput={(params) => (<TextField {...params} 
                                              label="Companhia Aérea" 
                                              fullWidth
                                              {...getFieldProps('id_companhia_aerea')}
                                              error={Boolean(touched.id_companhia_aerea && errors.id_companhia_aerea)}
                                              helperText={touched.id_companhia_aerea && errors.id_companhia_aerea}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              value={formik.values?.id_companhia_aerea}
                                              />
                                            )}
                  isOptionEqualToValue={(option, value) => {
                      if (value === "" || value.id_companhia_aerea === option.id_companhia_aerea)
                          return true; 
                  }}
              />
              <TextField
                fullWidth
                label="Origem"
                {...getFieldProps('origem')}
                error={Boolean(touched.origem && errors.origem)}
                helperText={touched.origem && errors.origem}
              />
              <TextField
                fullWidth
                label="Destino"
                {...getFieldProps('destino')}
                error={Boolean(touched.destino && errors.destino)}
                helperText={touched.destino && errors.destino}
              />
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                fullWidth
                label="Código Reserva"
                {...getFieldProps('codigo_reserva')}
                error={Boolean(touched.codigo_reserva && errors.codigo_reserva)}
                helperText={touched.codigo_reserva && errors.codigo_reserva}
              />
              <LocalizationProvider dateAdapter={AdapterDayjs} locale="pt-br" >
                <DatePicker
                  label="Data Ida"
                  value={formik.values?.data_ida}
                  onChange={(newValue) => {
                    setFieldValue('data_ida', newValue, false); 
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth/>}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs} locale="pt-br" >
                <DatePicker
                  label="Data Volta"
                  value={formik.values?.data_volta}
                  onChange={(newValue) => {
                    setFieldValue('data_volta', newValue, false); 
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth/>}
                />
              </LocalizationProvider>
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <Autocomplete
                getOptionLabel={(resultado) => resultado.nome_fantasia || ""}
                options={fornecedores}
                fullWidth
                value={fornecedor}
                onChange={(e, value) => { 
                  setFieldValue('id_fornecedor', value?.id_fornecedor, false) 
                  setFornecedor({id_fornecedor: value?.id_fornecedor, nome_fantasia: value?.nome_fantasia})
                }}
                renderInput={(params) => (<TextField {...params} 
                                            label="Fornecedor" 
                                            fullWidth
                                            {...getFieldProps('id_fornecedor')}
                                            error={Boolean(touched.id_fornecedor && errors.id_fornecedor)}
                                            helperText={touched.id_fornecedor && errors.id_fornecedor}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={formik.values?.id_fornecedor}
                                            />
                                          )}
                isOptionEqualToValue={(option, value) => {
                    if (value === "" || value.id_fornecedor === option.id_fornecedor)
                        return true; 
                }}
            />
            <Autocomplete
                getOptionLabel={(resultado) => resultado.descricao || ""}
                options={produtos}
                fullWidth
                value={produto}
                onChange={(e, value) => { 
                  setFieldValue('id_produto', value?.id_produto, false) 
                  setProduto({id_produto: value?.id_produto, descricao: value?.descricao})
                }}
                renderInput={(params) => (<TextField {...params} 
                                            label="Produto/Serviço" 
                                            fullWidth
                                            {...getFieldProps('id_produto')}
                                            error={Boolean(touched.id_produto && errors.id_produto)}
                                            helperText={touched.id_produto && errors.id_produto}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={formik.values?.id_produto}
                                            />
                                          )}
                isOptionEqualToValue={(option, value) => {
                    if (value === "" || value.id_produto === option.id_produto)
                        return true; 
                }}
            />
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField
              fullWidth
              label="Qtde Venda"
              {...getFieldProps('qtde_venda')}
              error={Boolean(touched.qtde_venda && errors.qtde_venda)}
              helperText={touched.qtde_venda && errors.qtde_venda}
            />
            <NumberFormat
              fullWidth
              label="Valor Venda"
              {...getFieldProps('valor_venda')}
              error={Boolean(touched.valor_venda && errors.valor_venda)}
              helperText={touched.valor_venda && errors.valor_venda}
              customInput={TextField}
              decimalSeparator={','}
            />
            <TextField 
              select
              fullWidth
              label="Forma de Pagamento"
              value={formaPagamento}
              onChange={(ev) => {
                setFieldValue('forma_pagamento', ev.target.value, false) 
                setFormaPagamento(ev.target.value)
              }}
            >
              <MenuItem value ="1">Dinheiro</MenuItem>
              <MenuItem value ="2">PIX</MenuItem> 
              <MenuItem value ="3">Cartão de Crédito</MenuItem>
              <MenuItem value ="4">Cartão de Débito</MenuItem>
            </TextField>
          </Stack>

          <Stack spacing={3}>
            {status.type === 'erro' ? <Alert severity="error">{status.mensagem}</Alert> : ""}
            {status.type === 'success' ? <Alert severity="success">{status.mensagem}</Alert> : ""}
          </Stack>

          <ThemeProvider theme={Theme}>
            <LoadingButton fullWidth size="large" type="submit" variant="contained" color="neutral" loading={isSubmitting}>
              Alterar
            </LoadingButton>
          </ThemeProvider>
        </Stack>  
      </Form>
    </FormikProvider>
  );
}
